'use strict';

import { Entity } from '../Entity';
import type { User } from './User';

export interface UserApiTokenData {
  id?: number;
  user?: User;
  name?: string;
  token?: string;
  dateTimeCreated?: string;
  lastUsedAt?: string | null;
  expiresAt?: string | null;
}

export class UserApiToken extends Entity {
  protected id;

  protected user;

  protected name;

  protected token;

  protected dateTimeCreated;

  protected lastUsedAt;

  protected expiresAt;

  constructor() {
    super();
  }

  public hydrate(data: UserApiTokenData) {
    this.id = data.id;

    this.user = data.user;

    this.name = data.name;

    this.token = data.token;

    this.dateTimeCreated = data.dateTimeCreated;

    this.lastUsedAt = data.lastUsedAt;

    this.expiresAt = data.expiresAt;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getUser() {
    return this.user;
  }

  public setUser(user) {
    this.user = user;

    return this;
  }

  public getName() {
    return this.name;
  }

  public setName(name) {
    this.name = name;

    return this;
  }

  public getToken() {
    return this.token;
  }

  public setToken(token) {
    this.token = token;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getLastUsedAt() {
    return this.lastUsedAt;
  }

  public setLastUsedAt(lastUsedAt) {
    this.lastUsedAt = lastUsedAt;

    return this;
  }

  public getExpiresAt() {
    return this.expiresAt;
  }

  public setExpiresAt(expiresAt) {
    this.expiresAt = expiresAt;

    return this;
  }

  public isExpired(): boolean {
    if (!this.expiresAt) {
      return false;
    }
    return new Date(this.expiresAt) < new Date();
  }
}
